var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.fileExistShow
    ? _c("div", { staticClass: "popup" }, [
        _c("div", { staticClass: "content", attrs: { id: "fileExist" } }, [
          _c("div", { staticClass: "title" }, [
            _c("span", [
              _vm._v(_vm._s(_vm.$t("language.cloudExploer.fileExists")))
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "icon white-close dialog-close",
              on: {
                click: function($event) {
                  return _vm.checkOption(5)
                }
              }
            })
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "file-exist-content" }, [
            _vm._v(
              "\n      " +
                _vm._s(_vm.$t("language.cloudExploer.chooseOption")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "file-exist-footer" }, [
            _c(
              "button",
              {
                staticStyle: { float: "left" },
                on: {
                  click: function($event) {
                    return _vm.checkOption(2)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.skip")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticStyle: { "vertical-align": "center" },
                on: {
                  click: function($event) {
                    return _vm.checkOption(4)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.common.replace")))]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticStyle: { float: "right" },
                on: {
                  click: function($event) {
                    return _vm.checkOption(0)
                  }
                }
              },
              [_vm._v(_vm._s(_vm.$t("language.popup.rename")))]
            )
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0be51daa", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be51daa","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/cloud_exploer_popups/file_exist_popup.vue
// module id = null
// module chunks = 